<div [class.no-rating]="!hasRating" class="star-icon">
  <rt-icon [name]="iconName" size="small"></rt-icon>
</div>
<div class="rate-number">
  {{ roundedRating }}
</div>
